export default {
  birthdays: [],
  selectedUser: null,
  error: false,
  errorMessage: '',
  selectedDay: null
}